<!--道路等级超速提醒-->
<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('speedlimit.RoadspeedWarn')"
      :visible.sync="dialogVisible"
      width="450px"
    >
      <el-divider></el-divider>
      <div style="margin: 0px 20px">
        <div style="text-align: left">
          <div style="margin-bottom: 16px">
            <span style="font-weight: bold; font-size: 12px; color: #0f1a3a">{{
              $t("speedlimit.limitspeedset")
            }}</span>
          </div>
          <el-form :size="size" label-width="120px">
            <limitvalueset v-model="highLimit" :label="$t('speedlimit.高速')" />
            <limitvalueset
              v-model="nationalLimit"
              :label="$t('speedlimit.国道')"
            />
            <limitvalueset
              v-model="provinceLimit"
              :label="$t('speedlimit.省道')"
            />
            <limitvalueset
              v-model="countyLimit"
              :label="$t('speedlimit.县道')"
            />
            <limitvalueset
              v-model="countryLimit"
              :label="$t('speedlimit.乡道')"
            />
            <limitvalueset
              v-model="villageLimit"
              :label="$t('speedlimit.村道')"
            />
            <limitvalueset
              v-model="otherLimit"
              :label="$t('speedlimit.其他')"
            />
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" :size="size">{{
          $t("public.cancel")
        }}</el-button>
        <el-button type="primary" @click="saveConfig" :size="size">{{
          $t("public.confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import limitvalueset from "./limitvalueset";
import { mapState } from "vuex";
export default {
  components: {
    limitvalueset,
  },
  data() {
    return {
      highLimit: 40,
      nationalLimit: 40,
      provinceLimit: 40,
      countyLimit: 40,
      countryLimit: 40,
      villageLimit: 40,
      otherLimit: 40,
      dialogVisible: false,
    };
  },
  methods: {
    show() {
      //获取现有的配置，如果没有，一个默认值
      this.dialogVisible = true;
    },
    saveConfig() {
      //保存配置，关闭
      //数字类型判断
      //保存
      this.$api
        .saveCompOverSpeedConfig({
          CompanyID: this.operator.CompanyId,
          HighLimit: this.highLimit,
          NationalLimit: this.nationalLimit,
          ProvinceLimit: this.provinceLimit,
          CountyLimit: this.countyLimit,
          CountryLimit: this.countryLimit,
          VillageLimit: this.villageLimit,
          OtherLimit: this.otherLimit,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              message: this.$t("public.hasSaved"),
              type: "success",
            });
          } else {
            this.$message({
              message: this.$t("public.SaveFail"),
              type: "error",
            });
          }
        });
      this.dialogVisible = false;
    },
    queryCompanyConfig() {
      this.$api
        .queryCompOverSpeedConfig({
          CompanyID: this.operator.CompanyId,
        })
        .then((res) => {
          if (res) {
            this.highLimit = res.HighLimit;
            this.nationalLimit = res.NationalLimit;
            this.provinceLimit = res.ProvinceLimit;
            this.countyLimit = res.CountyLimit;
            this.countryLimit = res.CountryLimit;
            this.villageLimit = res.VillageLimit;
            this.otherLimit = res.OtherLimit;
          }
        });
    },
  },
  mounted() {
    this.queryCompanyConfig();
  },
  computed: {
    ...mapState({
      size: (state) => state.app.size,
      operator: (state) => state.user.operator,
    }),
  },
};
</script>
